import type { Plan } from "@circle-react/types";
import { BillingCurrency } from "./BillingCurrency";
import { BillingCycle } from "./BillingCycle";
import { Features } from "./Features";
import { PlanHeaders } from "./PlanHeaders";
import { TopSection } from "./TopSection";

interface PlanProps {
  plans: Plan[];
}

export const PlansDesktop = ({ plans }: PlanProps) => {
  const gridCols = plans.length === 4 ? "grid-cols-5" : "grid-cols-4";

  return (
    <div className="bg-primary mx-auto p-8" data-testid="plans-table-desktop">
      <TopSection />
      <div
        className={`bg-primary sticky top-16 z-10 mb-2 grid pb-2 ${gridCols} grid-rows-1 pt-2`}
      >
        <div>
          <BillingCycle />
          <div className="mt-2">
            <BillingCurrency />
          </div>
        </div>

        {plans.map((plan: Plan) => (
          <PlanHeaders plan={plan} key={plan.id} />
        ))}
      </div>

      <Features />
    </div>
  );
};
